import React from "react";
import EnrollmentSection from "../components/EnrollmentSection";
import "./Home.css";
import Hero from "../components/Hero";
import TestimonialSlides from "../components/TestimonialSlides";
import OpportunitySection from "../components/OpportunitySection";
import PartnerSchools from "./PartnerSchools";


const Home = () => {
    return (
        <div className="home-container">
            <Hero/>
            <div style={{
                textAlign: "center",
                backgroundColor: "white",
                padding: "5px",
            }}>
                {/* Added Sections */}
                <OpportunitySection/>
                <TestimonialSlides/>
                <br/> <br/> <br/> <br/>
                <EnrollmentSection/>
                <br/> <br/>
                <PartnerSchools/>
            </div>
        </div>
    );
};

export default Home;
